import { createSelector } from 'reselect';
import {selectNotifications} from "../../selectors/root";
const selectData = (state: any) => state.notifications.data || {};
const selectStatus = (state: any) => state.notifications.status;
const selectActiveNotificationId = (state: any) => state.ui.activeNotification;
const selectUsers = (state: any) => state.users.firebase;

export const makeNotificationsList = createSelector(
    [selectData],
    notifications => {
        return Object.keys(notifications)
            .map(key => {
                let notification = notifications[key];
                let recipients = notification.recipients ? notification.recipients : {};
                return {
                    id: key,
                    ...notification,
                    recipientCount: Object.keys(recipients).length,
                };
            })
            .sort(function(a, b) {
                return b.timestamp - a.timestamp;
            });
    },
);

export const selectActiveNotification = createSelector(
    [selectActiveNotificationId, selectData],
    (id, data) => {
        //Notification id, notification data, status count, custom recipients array
        return data[id];
    },
);

export const selectNotificationStats = createSelector(
    [selectNotifications],
    (notifications) => {
       return notifications.stats
    },
);


export const makeActiveNotification = createSelector(
    [selectActiveNotificationId, selectData, selectStatus, selectUsers],
    (id, data, status, activeUsers) => {
        let rec: any = [];
        interface IStatusCount {
            [key: string]: number;
        }
        let statusCount: IStatusCount = {
            sent: 0,
            notSent: 0,
            sending: 0,
            error: 0,
        };

        if (status && status[id]) {
            rec = [
                ...Object.keys(status[id]) //Build our custom recipients array
                    .map(key => {
                        const recipientStatus = status[id][key].status;
                        const { lastChanged } = status[id][key];

                        statusCount[recipientStatus] = statusCount[recipientStatus] + 1;

                        const obj = {
                            id: key, //receipient id
                            name: activeUsers[key], //recipient name
                            lastChanged,
                            status: status[id][key]['status'],
                            // statusIcon: status[id][key]['statusIcon'],
                            // ...status[id][key], //receipient information
                        };
                        return obj;
                    }),
            ];
        }
        //Notification id, notification data, status count, custom recipients array
        return {
            id,
            ...data[id],
            statusCount,
            recipients: rec,
        };
    },
);
